/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ISurveyOptionGroup } from 'app/shared/model/survey-option-group.model';
import { ISurveySections } from 'app/shared/model/survey-sections.model';
import { ISurveyInputType } from 'app/shared/model/survey-input-type.model';

export interface ISurveyQuestion {
  id?: string;
  parentId?: string | null;
  questionName?: string;
  questionSubtext?: string | null;
  questionRequired?: boolean | null;
  answerRequired?: boolean | null;
  allowMutipleOptionSurveyAnswer?: boolean | null;
  dependentQuestionId?: string | null;
  dependentQuestionOptionId?: string | null;
  dependentAnswerId?: string | null;
  sortOrder?: number | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  optionGroup?: ISurveyOptionGroup | null;
  surveySection?: ISurveySections;
  inputType?: ISurveyInputType;
}

export const defaultValue: Readonly<ISurveyQuestion> = {
  questionRequired: false,
  answerRequired: false,
  allowMutipleOptionSurveyAnswer: false,
  active: false,
};
